import { Link } from "gatsby";
import * as React from "react";

import { NewsletterInput } from "components/NewsletterInput";

import FooterLogoImg from "../../assets/logo-white.inline.svg";
import { BodyText, Section } from "../../styles";
import { navItems } from "../Nav/navItems";
import {
  FooterBottom,
  FooterContainer,
  FooterContent,
  FooterHeader,
  FooterLink,
  FooterMenuItem,
} from "./Footer.styles";

export const Footer: React.FC = () => {
  return (
    <FooterContainer className="relative flex items-center justify-between pt-7 lg:p-8 lg:pb-20">
      <Section>
        <FooterHeader className="pb-10 lg:flex lg:items-center lg:justify-between lg:pb-16 lg:pt-8">
          <Link to="/">
            <FooterLogoImg />
          </Link>
          <div className="mt-8 lg:mt-0 lg:flex lg:flex-1 lg:items-center lg:justify-end">
            <NewsletterInput />
          </div>
        </FooterHeader>
        <FooterContent className="flex flex-col justify-between gap-x-6 pb-6 lg:flex-row lg:pb-20">
          {navItems
            .filter(({ url }) => url !== "/contact-us")
            .map(({ children, title }, index) => (
              <div className="mb-8" key={index}>
                <FooterMenuItem className="pb-6">{title}</FooterMenuItem>
                {children?.map(({ title, url }) => (
                  <FooterLink className="pb-6" key={url} to={url}>
                    {title}
                  </FooterLink>
                ))}
              </div>
            ))}
          <div className="mb-8">
            <FooterMenuItem className="pb-6">Contact us</FooterMenuItem>
            <BodyText $variant="b6reg" className="pb-6">
              125 Park Avenue
              <br />
              25th Floor
              <br />
              New York, NY
              <br />
              10017
              <br />
            </BodyText>
            <BodyText $variant="b6reg" className="pb-6">
              hello@exponentialmarkets.com
            </BodyText>
          </div>
        </FooterContent>
        <FooterBottom className="flex flex-col items-start pt-6 lg:flex-row lg:items-stretch">
          <BodyText $variant="b6impactbold" className="mt-12 lg:mt-0">
            &copy; 2024 All rights reserved
          </BodyText>
          <div className="flex items-stretch lg:block lg:flex-col">
            <BodyText
              $variant="b6impactbold"
              className="flex flex-col lg:block"
            >
              <Link to="/terms-of-use" className="py-4 lg:ml-16 lg:p-0">
                Terms of Use
              </Link>
              <Link to="/privacy-policy" className="py-4 lg:ml-16 lg:p-0">
                Privacy Policy
              </Link>
            </BodyText>
          </div>
        </FooterBottom>
      </Section>
    </FooterContainer>
  );
};
